export default __webpack_public_path__ + "static/media/translations.48169a17.csv";